import { Button, Flex, Loading, Typography } from '@iheartjane/reefer';

interface WizardLoadingProps {
  onCancel: () => void;
}

export function WizardLoading({ onCancel }: WizardLoadingProps) {
  return (
    <Flex
      alignItems="center"
      flexDirection="column"
      gap={24}
      justifyContent="center"
      p={24}
      height="100%"
    >
      <Typography variant="h2-semibold" mt="auto">
        Your top matches are loading&hellip;
      </Typography>
      <Flex my={32} position="relative">
        <Loading size="sm" />
      </Flex>
      <Typography textAlign="center" color="grays-mid">
        Hang tight, we&rsquo;re pulling your matches off the shelf now.
      </Typography>
      <Button
        mt="auto"
        variant="tertiary"
        label="Cancel search"
        onClick={onCancel}
      />
    </Flex>
  );
}
